import { render, staticRenderFns } from "./teacher-info.vue?vue&type=template&id=3c630fbe&scoped=true&"
import script from "./teacher-info.vue?vue&type=script&lang=js&"
export * from "./teacher-info.vue?vue&type=script&lang=js&"
import style0 from "./teacher-info.vue?vue&type=style&index=0&id=3c630fbe&lang=stylus&scoped=true&"
import style1 from "./teacher-info.vue?vue&type=style&index=1&id=3c630fbe&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c630fbe",
  null
  
)

export default component.exports